import type { PlatformUiDto } from '@robu/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api-client';
import { queryKeys } from '../../lib/query-keys';

export const platformApi = {
  ui: () => api.get<PlatformUiDto>('/platform/ui'),
};

export function usePlatformUi() {
  return useQuery({
    queryKey: queryKeys.platform.ui(),
    queryFn: () => platformApi.ui(),
    staleTime: 60_000,
  });
}
